export const WEB_API_BASE =
	import.meta.env.VITE_WEB_API_BASE || "http://localhost:8080";
export const USE_SAMPLE =
	(import.meta.env.VITE_USE_SAMPLE || "true") === "true";
